import { useSignal } from "@preact/signals-react";
import { useNavigate } from "react-router";

import Screen from "components/Meta/Screen";
import Board from "componentsv2/board/Board";
import { layout as layoutActivity } from "../layoutActivity";
import { genStoreId } from "componentsv2/tools/functions";

function ViewActivity(props) {
  const navigate = useNavigate();
  const currentView = useSignal("list");
  const recordStoreId = useSignal(null);
  const { config } = props;
  const _layoutActivity = layoutActivity(config);

  const handlereturn = () => {
    navigate(-1);
  };

  function handleView(action, recStoreId) {
    if (action === "return") {
      handlereturn();
      return;
    }
    if (["edit", "add"].includes(action)) {
      currentView.value = "form";
      recordStoreId.value =
        recStoreId || genStoreId(_layoutActivity.model, null);
    } else {
      currentView.value = "list";
      recordStoreId.value = null;
    }
  }
  return (
    <Screen>
      <Board
        layout={_layoutActivity}
        returnFilter={handlereturn}
        currentView={currentView}
        showBackButton={true}
        setView={currentView}
        handleView={handleView}
        recordStoreId={recordStoreId}
      />
    </Screen>
  );
}

export default ViewActivity;
